/** Lowercase-hex SHA-256, replacing the `sha256` npm package.
 *  Requires a secure context (https or localhost) — both dev and prod qualify. */
export async function sha256Hex(text: string): Promise<string> {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(text),
  );
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
